import { format } from "date-fns";
import IContainerStatusViewModel from "interfaces/IContainerStatusViewModel";

const LastUpdatedTemplate = (props: IContainerStatusViewModel): any => {
  const container = { props };
  if (!container.props.lastUpdatedTimestamp) {
    return <></>;
  }

  return (
    <>
      <span className="fw-bold">
        {format(container.props.lastUpdatedTimestamp, "dd MMM yyyy")}
      </span>
      <br />
      <span>
        {format(container.props.lastUpdatedTimestamp, "HH:mm")}
      </span>
    </>
  );
};
export default LastUpdatedTemplate;
